import { SHAPES, randomShapeFrom } from "./blockShapes";
import { hasAnyValidMove, pieceFitsAnywhere } from "./gameLogic";

const MAX_RANDOM_ATTEMPTS = 64;

function boardHasEmptyCell(board) {
    for (let r = 0; r < board.length; r++) {
        for (let c = 0; c < board[r].length; c++) {
            if (board[r][c] === null) return true;
        }
    }
    return false;
}

function isBoardEmpty(board) {
    for (let r = 0; r < board.length; r++) {
        for (let c = 0; c < board[r].length; c++) {
            if (board[r][c] !== null) return false;
        }
    }
    return true;
}

function cloneShapeDef(shapeDef, rng) {
    return { ...shapeDef, uid: rng().toString(36).slice(2, 10) };
}

function buildFallbackTray(board, rng) {
    const fitting = SHAPES.filter((s) => pieceFitsAnywhere(board, s.cells));
    if (fitting.length === 0) {
        return [
            randomShapeFrom(rng),
            randomShapeFrom(rng),
            randomShapeFrom(rng),
        ];
    }
    const pinned = cloneShapeDef(
        fitting[Math.floor(rng() * fitting.length)],
        rng
    );
    const a = randomShapeFrom(rng);
    const b = randomShapeFrom(rng);
    const slots = [pinned, a, b];
    const pinAt = Math.floor(rng() * 3);
    if (pinAt !== 0) {
        const t = slots[0];
        slots[0] = slots[pinAt];
        slots[pinAt] = t;
    }
    return slots;
}

/**
 * Build a 3-piece tray such that at least one piece has a legal placement
 * on the given board (same predicate as game-over).
 *
 * @param {Array<Array<null|object>>} board
 * @param {() => number} [rng] values in [0, 1)
 * @returns {[object, object, object]}
 */
export function createTray(board, rng = Math.random) {
    if (isBoardEmpty(board)) {
        return [
            randomShapeFrom(rng),
            randomShapeFrom(rng),
            randomShapeFrom(rng),
        ];
    }

    if (!boardHasEmptyCell(board)) {
        return [
            randomShapeFrom(rng),
            randomShapeFrom(rng),
            randomShapeFrom(rng),
        ];
    }

    for (let n = 0; n < MAX_RANDOM_ATTEMPTS; n++) {
        const tray = [
            randomShapeFrom(rng),
            randomShapeFrom(rng),
            randomShapeFrom(rng),
        ];
        if (hasAnyValidMove(board, tray)) return tray;
    }

    return buildFallbackTray(board, rng);
}
